document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('feature');
    const el = document.querySelector('#main');
    const allowedValues = ['thrusting', 'suction', 'heating', 'best'];
    if (myParam && allowedValues.includes(myParam) && el) {
        el.classList.add('rosy-parameter-sorting-' + myParam);
    } else {
        el.classList.remove('rosy-parameter-sorting');
    }
}) 